import { idFromSlug } from './listingSlug';

/*
 * Listing type + id of the details page in the current URL. Works for
 *   /trip/details/:id                (current site)
 *   /v2/trip/details/:name-:id       (v2, name + id)
 *
 *   const { type, packId } = detailsRoute();
 */
export function detailsRoute(pathname = window.location.pathname) {
    const parts = pathname.split('/').filter(Boolean);
    if (parts[0] === 'v2') parts.shift();
    return { type: parts[0], packId: idFromSlug(parts[2]) };
}
